<template>
    <v-card min-height="450px" v-if="screener" class="ma-3 hover-overlay-card" outlined>
        <a :href="`/screeners/${screener.id}`" class="full-card-link">
            <div v-if="screener && screener.film_sections && screener.film_sections.length" class="card-wrapper">
                <span class="text-split text-top-right custom-text">{{ filmSectionSplit.first }}</span>
                <span class="text-split text-right-vertical custom-text">{{ filmSectionSplit.second }}</span>
            </div>
            <div class="v-img-wrapper">
                <v-img :src="screener.thumbnail_url" aspect-ratio="16/9" class="card-image">
                </v-img>
            </div>
            <v-card-text class="py-2">
                <div class="bg-red pa-2">
                    <h2 class="mb-0 pb-0">
                        {{ screener.title[currentLocale] }}
                    </h2>
                    <h3 v-if="directorName">
                        {{ $t('screener.details.page.header.director.by') }} {{ directorName }}
                    </h3>
                </div>
                <div v-if="screener.description" class="movie-description px-2 mt-2" v-html="screener.description[currentLocale]"></div>
            </v-card-text>
            <v-layout class="px-2 font-weight-bold" row wrap>
                <v-flex xs12 md12 v-if="screener.screening_starts_at || screener.screening_ends_at">
                    <v-layout align-center>
                        <v-img min-width="25px" max-width="25px" class="mr-1" contain :src="playIconSrc"></v-img>
                        <span v-if="screener.screening_starts_at" class="text-size">{{ formatDateTime(screener.screening_starts_at) }}</span>
                        <span v-if="screener.screening_ends_at" class="text-size">&nbsp;→&nbsp;{{ formatDateTime(screener.screening_ends_at) }}</span>
                        <span v-if="screener.film_durations.length" class="text-size">&nbsp;|&nbsp;{{ screener.film_durations[0] }}'</span>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md12 class="mt-2" v-if="(screener.qa_info && screener.qa_info.title)">
                    <v-layout align-center>
                        <v-img max-width="25px" class="mr-1" contain :src="qandaIconSrc"></v-img>
                        <span v-if="screener.qa_info.qa_datetime" class="text-size">{{ formatDateTime(screener.qa_info.qa_datetime) }}</span>
                    </v-layout>
                </v-flex>
                <v-flex xs12 md12 class="footer-section pt-3 pb-2">
                    <v-layout align-center justify-end class="cursor-pointer" @click.stop="goToScreenerPage(screener.id, {'initEnr':1})" v-if="isScreeningPaid(screener) && isSinglePricingAvailableOnScreening(screener)" >
                        <v-img max-width="25px" class="mr-1" contain :src="cartIconSrc"></v-img>
                        <span >
                            {{ getCurrencySymbol(screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE][0].currency)}}&nbsp;{{screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.SINGLE_PURCHASE][0].price}}
                        </span>
                    </v-layout>
                    <v-layout justify-end align-center v-else>
                        <v-img max-width="25px" class="mr-1" contain :src="cartIconSrc""></v-img>
                        <span >{{ $t('screener.program.free') }}</span>
                    </v-layout>
                </v-flex>
            </v-layout>
        </a>
    </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { currencySymbol } from "@/mixins/currencySymbol";
import { utcToTz } from "@/helpers";
export default {
    name: "ProgramScreenerWidget",
    props:{
        screener:{
            type:Object,
            default: null
        }
    },
    mixins: [currencySymbol],
    computed: {
        ...mapGetters("screening", {
            isScreeningPaid: "isScreeningPaid",
            isSinglePricingAvailableOnScreening: "isSinglePricingAvailableOnScreening"
        }),
        ...mapGetters("company", {
            timezone: "getSelectedCompanyTimezone",
        }),
        currentLocale() {
            return this.$i18n.locale;
        },
        filmSectionSplit() {
            const text = (this.screener && this.screener.film_sections && this.screener.film_sections[0]) || "";

            if (!text) {
                return { first: "", second: "" }; // Return empty strings if text is null/undefined/empty
            }

            const words = text.split(" ");
            const splitIndex = Math.ceil(words.length / 2);

            return {
                first: words.slice(0, splitIndex).join(" "),
                second: words.slice(splitIndex).join(" "),
            };
        },
        directorName() {
            let __this = this
            if (this.screener.director_names.length > 0) {
                return this.screener.director_names.join(', ');
            }else{
                let directorArray = [];
                if (this.screener.screener_films.length > 0) {
                    this.screener.screener_films.forEach((element) => {
                        if (element.directors.length > 0 ) {
                            element.directors.forEach((director_element) => {
                                directorArray.push(director_element.name[__this.currentLocale]);
                            })
                        }
                    })
                }
                return directorArray.join(', ');
            }
        },

        isDarkTheme() {
            return this.$store.getters["app/darkMode"];
        },

        playIconSrc() {
            return this.isDarkTheme
                ? require("@/assets/screen-white.png")
                : require("@/assets/screen-black.png");
        },

        qandaIconSrc() {
            return this.isDarkTheme
                ? require("@/assets/icons/q-and-a-white.png")
                : require("@/assets/icons/q-and-a-black.png");
        },

        cartIconSrc() {
            return this.isDarkTheme
                ? require("@/assets/pricing-icon-white.png")
                : require("@/assets/pricing-icon-black.png");
        }
    },
    methods:{
        formatDateTime(datetimeString) {
            return utcToTz(datetimeString, this.timezone, 'MMM D | HH:mm')
    },
        goToScreenerPage(screenerId, query={}){
            console.log('screener -->', screenerId)
            if(!screenerId){
                return;
            }
            this.$router.push({
                name: "screeners.overview",
                params: {
                    screener_id: screenerId
                },
                query: query
            });
        }
    }

}
</script>

<style scoped>
.v-img-wrapper{
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 aspect ratio (9 / 16 * 100) */
    overflow: hidden;
}
.border{
    border:1px solid white;
}
.play-icon {
  font-size: 5rem;
}
.bg-red{
    background: #b32e2f;
}
.movie-description {
    font-weight: 700;
    font-family: roboto;
    font-size: 12pt;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
.movie-description >>> p{
    margin-bottom: 0px;
}
.hover-overlay-card {
    overflow: hidden;
}
.card-image {
    /* position: relative; */
    transition: transform 0.6s ease-in-out;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover; /* Ensures the image covers the entire container */
}
.card-image:hover {
    transform: scale(1.05);
    transform-origin: center
}
.card-image:hover .play-button {
    display: block;
}
/* Play button styles */
.play-button {
    display: none;
    position: relative;
    top: 24%;
    left: 36%;
    padding: 10px;
    transform: translate(-50%, -50%);
    height: 20px;
    width: 20px;
    background-color: none;
    border-radius: 50%;
    text-decoration: none;
}
.play-button::after {
    content: "\e037";
    font-family: 'Material Icons';
    top: 36%;
    left: 40%;
    transform: translate(-50%, -50%);
    font-size: 4rem;
    position: relative;
    padding: 10px;
    border: 2px solid #fff;
    color: white;
    border-radius: 50%;
}
.play-button:hover::after {
    color: #db0369;
    border: 2px solid #db0369;
}
.v-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: relative;
    overflow: visible;
}
.v-card-text {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.v-layout {
    align-items: stretch;
}
.card-wrapper {
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    pointer-events: none;
    overflow: visible;
}
.text-split {
    font-weight: bold;
    font-size: 10pt;
    color: inherit;
    z-index: 0;
    padding: 5px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.text-top-right {
    position: absolute;
    top: -9px;
    right: -10px;
}

.text-right-vertical {
    position: absolute;
    top: 16px;
    right: -34px;
    writing-mode: vertical-rl;
    text-orientation: mixed;
}
.full-card-link {
    text-decoration: none;
    color: inherit;
    display: block;
}
.footer-section {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 10px;
    background: inherit;
}
.custom-text {
    font-size: 12pt;
}
.text-size {
    font-size: 10pt;
}
@media (max-width: 795px) {
    .text-size {
        font-size: 8.5pt;
    }
}
@media (min-width: 960px) and (max-width: 994px) {
    .text-size {
        font-size: 7.5pt; /* Adjust the size as needed */
    }
}

@media (min-width: 994px) and (max-width: 1140px) {
    .text-size {
        font-size: 8.5pt; /* Adjust the size as needed */
    }
}
@media (min-width: 2300px) {
    .text-size {
        font-size: 11.8pt;
    }
}
</style>
